import { useEffect, useState } from 'react'

/** Animation state belongs to each mounted renderer; no global clock/subscription. */
export function usePatternTime(enabled: boolean, explicitTime?: number) {
  const [seconds, setSeconds] = useState(0)
  useEffect(() => {
    if (!enabled || explicitTime !== undefined) return () => { /* No frame scheduled. */ }
    let frame = 0
    let start: number | undefined
    let previous = -Infinity
    const tick = (now: number) => {
      start ??= now
      if (now - previous >= 1000 / 30) {
        setSeconds((now - start) / 1000)
        previous = now
      }
      frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => { cancelAnimationFrame(frame) }
  }, [enabled, explicitTime])
  return explicitTime ?? (enabled ? seconds : 0)
}
